import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.push.js";
import { login, getUserInfo } from '@/api/user';
import { jsonInBlacklist } from '@/api/jwt';
import router from '@/router/index';
import { setUserInfo } from '@/api/user';
export var user = {
  namespaced: true,
  state: {
    userInfo: {
      uuid: '',
      nickName: '',
      headerImg: '',
      authority: '',
      sideMode: 'dark',
      activeColor: '#1890ff',
      baseColor: '#fff'
    },
    token: '',
    merchantGrade: null,
    merchantId: '',
    blackBox: ''
  },
  mutations: {
    setUserInfo: function setUserInfo(state, userInfo) {
      // 这里的 `state` 对象是模块的局部状态
      state.userInfo = userInfo;
    },
    setToken: function setToken(state, token) {
      // 这里的 `state` 对象是模块的局部状态
      state.token = token;
    },
    setMerchantGrade: function setMerchantGrade(state, merchantGrade) {
      state.merchantGrade = merchantGrade;
    },
    setMerchantId: function setMerchantId(state, merchantId) {
      state.merchantId = merchantId;
    },
    setBlackBox: function setBlackBox(state, blackBox) {
      state.blackBox = blackBox;
    },
    NeedInit: function NeedInit(state) {
      state.userInfo = {};
      state.token = '';
      sessionStorage.clear();
      router.push({
        name: 'Init',
        replace: true
      });
    },
    LoginOut: function LoginOut(state) {
      state.userInfo = {};
      state.token = '';
      state.merchantGrade = null;
      state.merchantId = '';
      sessionStorage.clear();
      router.push({
        name: 'Login',
        replace: true
      });
      window.location.reload();
    },
    ResetUserInfo: function ResetUserInfo(state) {
      var userInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      state.userInfo = _objectSpread(_objectSpread({}, state.userInfo), userInfo);
    },
    ChangeActiveColor: function () {
      var _ChangeActiveColor = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(state, val) {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              state.userInfo.activeColor = val;
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function ChangeActiveColor(_x, _x2) {
        return _ChangeActiveColor.apply(this, arguments);
      }
      return ChangeActiveColor;
    }(),
    ChangeSideMode: function () {
      var _ChangeSideMode = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(state, val) {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              state.userInfo.sideMode = val;
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function ChangeSideMode(_x3, _x4) {
        return _ChangeSideMode.apply(this, arguments);
      }
      return ChangeSideMode;
    }(),
    ChangeBaseColor: function ChangeBaseColor(state, val) {
      state.userInfo.baseColor = val;
    }
  },
  actions: {
    GetUserInfo: function GetUserInfo(_ref) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var commit, res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref.commit;
              _context3.next = 1;
              return getUserInfo();
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                commit('setUserInfo', res.data.userInfo);
              }
              return _context3.abrupt("return", res);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    LoginIn: function LoginIn(_ref2, loginInfo) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var commit, dispatch, rootGetters, getters, res, asyncRouters;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref2.commit, dispatch = _ref2.dispatch, rootGetters = _ref2.rootGetters, getters = _ref2.getters;
              _context4.next = 1;
              return login(loginInfo);
            case 1:
              res = _context4.sent;
              if (!(res.code === 0)) {
                _context4.next = 4;
                break;
              }
              if (res.data.user.totpSecret) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", {
                needGoogleBinding: true,
                userInfo: res.data.user,
                token: res.data.token,
                merchantGrade: res.data.merchantGrade,
                merchantId: res.data.merchantId
              });
            case 2:
              // 正常登录流程
              commit('setUserInfo', res.data.user);
              commit('setToken', res.data.token);
              commit('setMerchantGrade', res.data.merchantGrade);
              commit('setMerchantId', res.data.merchantId);
              _context4.next = 3;
              return dispatch('router/SetAsyncRouter', {}, {
                root: true
              });
            case 3:
              asyncRouters = rootGetters['router/asyncRouters'];
              router.addRoutes(asyncRouters);
              router.push({
                name: getters['userInfo'].authority.defaultRouter
              });
              return _context4.abrupt("return", true);
            case 4:
              return _context4.abrupt("return", false);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    CompleteLoginAfterBinding: function CompleteLoginAfterBinding(_ref3, _ref4) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var commit, dispatch, rootGetters, getters, userInfo, token, merchantGrade, merchantId, asyncRouters;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref3.commit, dispatch = _ref3.dispatch, rootGetters = _ref3.rootGetters, getters = _ref3.getters;
              userInfo = _ref4.userInfo, token = _ref4.token, merchantGrade = _ref4.merchantGrade, merchantId = _ref4.merchantId;
              // 完成强制绑定后的登录流程
              commit('setUserInfo', userInfo);
              commit('setToken', token);
              commit('setMerchantGrade', merchantGrade);
              commit('setMerchantId', merchantId);
              _context5.next = 1;
              return dispatch('router/SetAsyncRouter', {}, {
                root: true
              });
            case 1:
              asyncRouters = rootGetters['router/asyncRouters'];
              router.addRoutes(asyncRouters);
              router.push({
                name: getters['userInfo'].authority.defaultRouter
              });
              return _context5.abrupt("return", true);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    LoginOut: function LoginOut(_ref5) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var commit, res;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref5.commit;
              _context6.next = 1;
              return jsonInBlacklist();
            case 1:
              res = _context6.sent;
              if (res.code === 0) {
                commit('LoginOut');
              }
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    changeActiveColor: function changeActiveColor(_ref6, data) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var commit, state, res;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref6.commit, state = _ref6.state;
              _context7.next = 1;
              return setUserInfo({
                activeColor: data,
                ID: state.userInfo.ID
              });
            case 1:
              res = _context7.sent;
              if (res.code === 0) {
                commit('ChangeActiveColor', data);
                _Message({
                  type: 'success',
                  message: '设置成功'
                });
              }
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    changeSideMode: function changeSideMode(_ref7, data) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var commit, state, res;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref7.commit, state = _ref7.state;
              _context8.next = 1;
              return setUserInfo({
                sideMode: data,
                ID: state.userInfo.ID
              });
            case 1:
              res = _context8.sent;
              if (res.code === 0) {
                commit('ChangeSideMode', data);
                _Message({
                  type: 'success',
                  message: '设置成功'
                });
              }
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    changeBaseColor: function changeBaseColor(_ref8, data) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var commit, state, res;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref8.commit, state = _ref8.state;
              _context9.next = 1;
              return setUserInfo({
                baseColor: data,
                ID: state.userInfo.ID
              });
            case 1:
              res = _context9.sent;
              if (res.code === 0) {
                commit('ChangeBaseColor', data);
                _Message({
                  type: 'success',
                  message: '设置成功'
                });
              }
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    }
  },
  getters: {
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    token: function token(state) {
      return state.token;
    },
    merchantGrade: function merchantGrade(state) {
      return state.merchantGrade;
    },
    merchantId: function merchantId(state) {
      return state.merchantId;
    },
    mode: function mode(state) {
      return state.userInfo.sideMode;
    },
    sideMode: function sideMode(state) {
      if (state.userInfo.sideMode === 'dark') {
        return '#191a23';
      } else if (state.userInfo.sideMode === 'light') {
        return '#fff';
      } else {
        return state.userInfo.sideMode;
      }
    },
    baseColor: function baseColor(state) {
      if (state.userInfo.sideMode === 'dark') {
        return '#fff';
      } else if (state.userInfo.sideMode === 'light') {
        return '#191a23';
      } else {
        return state.userInfo.baseColor;
      }
    },
    activeColor: function activeColor(state) {
      if (state.userInfo.sideMode === 'dark' || state.userInfo.sideMode === 'light') {
        return '#1890ff';
      }
      return state.userInfo.activeColor;
    }
  }
};